// extracted by mini-css-extract-plugin
export default {"copyToClipboard":"CopyToClipboard_copyToClipboard__KinrP"};